// Cardápio da Pomodoro Rosso: estilos, bases, ingredientes (com preço) e as
// pizzas prontas. Fonte única: o site (App.jsx) e a /api/cardapio (lida pelo
// PMS da Villa Éden para lançar pizzas no consumo) importam daqui. Só dados,
// sem JSX: os preços do /admin (overrides) são aplicados por cima.

export const TIPOS_PIZZA = [
  {
    id: "napoletana",
    name: "Pizza Napoletana",
    short: "Pizza Napoletana",
    emoji: "🍕",
    desc: "Massa macia e levemente elástica com cornicione (borda alta e levemente queimada). Assada em alta temperatura por pouco tempo. A típica pizza napoletana, do jeito que se faz em Nápoles.",
    tags: ["A típica pizza de Nápoles", "Cornicione alto e aerado", "Massa de 48 horas"],
  },
  {
    id: "romana",
    off: true, // Fora do cardápio por enquanto: o pizzaiolo não consegue fazer a romana neste período. Apague esta linha para voltar.
    name: "Pizza Romana",
    short: "Romana",
    emoji: "🫓",
    desc: "Massa fina e bem crocante, sem cornicione. Assada por mais tempo em temperatura menor. Textura mais seca e crocante em toda a superfície — ideal para quem prefere pizza fininha.",
    tags: ["Sem cornicione", "Bem crocante", "Massa fininha"],
  },
  {
    id: "calzone",
    name: "Calzone",
    short: "Calzone",
    emoji: "🥟",
    desc: "A mesma pizza, dobrada ao meio e fechada antes de ir ao forno. O recheio assa por dentro: o queijo derrete no vapor e a massa fica dourada por fora e macia por dentro. Vai fechado, come-se com as mãos ou no prato.",
    tags: ["Massa dobrada", "Recheio por dentro", "Queijo derretido"],
  },
];

export const BASES = [
  { id: "vermelha", name: "Base Vermelha", desc: "Massa Artesanal + Molho de Tomate", price: 80 },
  { id: "branca",   name: "Base Branca",   desc: "Massa Artesanal + Azeite de Oliva",  price: 80 },
];

export const WIZARD_STEPS = [
  { id: "tipo",      label: "Tipo",             required: true,  hint: "Escolha o estilo da sua pizza",   type: "tipo" },
  { id: "base",      label: "Base",             required: true,  hint: "Escolha a base da sua pizza",     type: "base" },
  { id: "queijos",   label: "Queijos",           required: true,  hint: "Escolha os queijos ou sem queijo", type: "multi",
    items: [
      { id: "sem_queijo",  name: "Sem Queijo",            price: 0,  tag: "Grátis" },
      { id: "mussarela",   name: "Mussarela Tradicional", price: 10 },
      { id: "bufala",      name: "Mussarela de Búfala",   price: 13 },
      { id: "gorgonzola",  name: "Gorgonzola",            price: 10 },
      { id: "parmesao",    name: "Parmesão Curado",       price: 5  },
      { id: "provolone",   name: "Provolone",             price: 10 },
    ]},
  { id: "proteinas", label: "Proteína",          required: false, hint: "Escolha uma proteína (opcional)", type: "single",
    items: [
      { id: "presunto",  name: "Presunto Cozido Especial", price: 10 },
      { id: "calabresa", name: "Calabresa Especial",        price: 10 },
      { id: "frango",    name: "Frango Desfiado",           price: 15 },
      { id: "salame",    name: "Salame Italiano",           price: 15 },
      { id: "peito_peru", name: "Peito de Peru",            price: 18 },
    ]},
  { id: "extras",    label: "Vegetais & Extras",  required: false, hint: "Adicione vegetais e extras (opcional)", type: "multi",
    items: [
      { id: "cebola_crua",         name: "Cebola Crua",         price: 0, tag: "Grátis" },
      { id: "cebola_caramelizada", name: "Cebola Caramelizada", price: 5 },
      { id: "tomate_cereja",       name: "Tomate Cereja",       price: 5 },
      { id: "rucula",              name: "Rúcula",              price: 5 },
      { id: "tomate_seco",         name: "Tomate Seco",         price: 10 },
      { id: "palmito",             name: "Palmito",             price: 8 },
      { id: "azeitona_verde",      name: "Azeitona Verde",      price: 5 },
      { id: "azeitona_roxa",       name: "Azeitona Roxa",       price: 5 },
      { id: "ovo",                 name: "Ovo",                 price: 5 },
    ]},
  { id: "toque",     label: "Toque Final",       required: false, hint: "Pestos e azeites especiais",      type: "multi",
    items: [
      { id: "pesto_genovese",    name: "Pesto Genovese",       price: 10 },
      { id: "pesto_tomate",      name: "Pesto Tomate Seco",    price: 10 },
      { id: "pesto_rucula",      name: "Pesto de Rúcula",      price: 10 },
      { id: "azeite_trufado",    name: "Azeite Trufado",       price: 20 },
      { id: "azeite_manjericao", name: "Azeite de Manjericão", price: 10 },
      { id: "trufa_branca",      name: "Tempero de Trufa Branca", price: 30, tag: "Aroma" },
      { id: "manjericao_fresco", name: "Manjericão Fresco",    price: 0,  tag: "Grátis" },
      { id: "nutella",           name: "Nutella",              price: 50, doce: true },
    ]},
  { id: "temperos",  label: "Temperos",          required: false, hint: "Escolha os temperos",             type: "multi",
    items: [
      { id: "oregano",  name: "Orégano",    price: 0,  tag: "Grátis" },
      { id: "alho",     name: "Alho Frito", price: 0,  tag: "Grátis" },
      { id: "tabasco",  name: "Tabasco",    price: 10 },
    ]},
];

// ─── PIZZAS SUGERIDAS ─────────────────────────────────────────────────────────

export const PIZZAS_SUGERIDAS = [
  {
    id: "margherita",
    name: "Margherita",
    tagline: "A rainha das pizzas: simples e perfeita",
    badge: "⭐ Favorita do pizzaiolo",
    desc: "Clássica italiana com mussarela e manjericão fresco",
    emoji: "🍕",
    custom: { tipo: "napoletana",
      base: { id: "vermelha", name: "Base Vermelha", desc: "Massa Artesanal + Molho de Tomate", price: 80 },
      selections: {
        queijos: ["mussarela"],
        toque: ["manjericao_fresco"],
      }
    }
  },
  {
    id: "salame_classica",
    name: "Salame & Mussarela",
    tagline: "Salame italiano de verdade: a pizza que nunca decepciona",
    desc: "Salame italiano com mussarela tradicional e orégano",
    emoji: "",
    custom: { tipo: "napoletana",
      base: { id: "vermelha", name: "Base Vermelha", desc: "Massa Artesanal + Molho de Tomate", price: 80 },
      selections: {
        queijos: ["mussarela"],
        proteinas: "salame",
        temperos: ["oregano"],
      }
    }
  },
  {
    id: "gorgonzola_trufada",
    name: "Gorgonzola Trufada",
    tagline: "Intensa e elegante: gorgonzola encontra o azeite trufado",
    desc: "Gorgonzola, parmesão e azeite trufado sobre molho de tomate",
    emoji: "",
    custom: { tipo: "napoletana",
      base: { id: "vermelha", name: "Base Vermelha", desc: "Massa Artesanal + Molho de Tomate", price: 80 },
      selections: {
        queijos: ["gorgonzola", "parmesao"],
        toque: ["azeite_trufado"],
        temperos: ["oregano"],
      }
    }
  },
  {
    id: "picante",
    name: "Diavola",
    tagline: "A picante: salame e Tabasco para quem gosta de fogo",
    badge: "🔥 Picante",
    desc: "Salame italiano, mussarela e Tabasco",
    emoji: "🌶️",
    custom: { tipo: "napoletana",
      base: { id: "vermelha", name: "Base Vermelha", desc: "Massa Artesanal + Molho de Tomate", price: 80 },
      selections: {
        queijos: ["mussarela"],
        proteinas: "salame",
        temperos: ["oregano", "tabasco"],
      }
    }
  },
  {
    id: "calabresa_cebola",
    name: "Calabresa & Cebola",
    tagline: "A brasileira de todo dia, com massa de 48 horas",
    desc: "Clássica brasileira com calabresa, mussarela e cebola crua",
    emoji: "🧅",
    custom: { tipo: "napoletana",
      base: { id: "vermelha", name: "Base Vermelha", desc: "Massa Artesanal + Molho de Tomate", price: 80 },
      selections: {
        queijos: ["mussarela"],
        proteinas: "calabresa",
        extras: ["cebola_crua"],
        temperos: ["oregano"],
      }
    }
  },
  {
    id: "gorgonzola_salame",
    name: "Gorgonzola & Salame",
    tagline: "Gorgonzola e salame: intensa, para paladares fortes",
    desc: "Gorgonzola e salame italiano com mussarela e orégano",
    emoji: "",
    custom: { tipo: "napoletana",
      base: { id: "vermelha", name: "Base Vermelha", desc: "Massa Artesanal + Molho de Tomate", price: 80 },
      selections: {
        queijos: ["mussarela", "gorgonzola"],
        proteinas: "salame",
        temperos: ["oregano"],
      }
    }
  },
  {
    id: "quatro_queijos",
    name: "Quatro Queijos",
    tagline: "Quatro queijos derretidos: a pizza dos apaixonados por queijo",
    desc: "Mussarela, gorgonzola, parmesão e provolone",
    emoji: "🧀",
    custom: { tipo: "napoletana",
      base: { id: "vermelha", name: "Base Vermelha", desc: "Massa Artesanal + Molho de Tomate", price: 80 },
      selections: {
        queijos: ["mussarela", "gorgonzola", "parmesao", "provolone"],
        temperos: ["oregano"],
      }
    }
  },
  {
    id: "genovese",
    name: "Genovese",
    tagline: "Pesto, tomate cereja e parmesão: um verão italiano",
    desc: "Pesto genovese, parmesão, tomate cereja e manjericão fresco",
    emoji: "🌿",
    custom: { tipo: "napoletana",
      base: { id: "vermelha", name: "Base Vermelha", desc: "Massa Artesanal + Molho de Tomate", price: 80 },
      selections: {
        queijos: ["mussarela", "parmesao"],
        extras: ["tomate_cereja"],
        toque: ["pesto_genovese", "manjericao_fresco"],
      }
    }
  },
  {
    id: "calabresa_alho",
    name: "Calabresa ao Alho",
    tagline: "Para quem gosta de sabor forte: alho frito e azeitona",
    desc: "Calabresa especial, mussarela, alho frito e azeitona",
    emoji: "🧄",
    custom: { tipo: "napoletana",
      base: { id: "vermelha", name: "Base Vermelha", desc: "Massa Artesanal + Molho de Tomate", price: 80 },
      selections: {
        queijos: ["mussarela"],
        proteinas: "calabresa",
        extras: ["azeitona_roxa"],
        temperos: ["oregano", "alho"],
      }
    }
  },
  {
    id: "bufalina",
    name: "Bufalina",
    tagline: "Búfala cremosa e tomate fresco: leveza italiana de verdade",
    desc: "Mussarela de búfala, tomate cereja e manjericão fresco",
    emoji: "🍅",
    custom: { tipo: "napoletana",
      base: { id: "vermelha", name: "Base Vermelha", desc: "Massa Artesanal + Molho de Tomate", price: 80 },
      selections: {
        queijos: ["bufala"],
        extras: ["tomate_cereja"],
        toque: ["manjericao_fresco"],
        temperos: ["oregano"],
      }
    }
  },
  {
    id: "cz_caprese",
    name: "Caprese",
    tagline: "O clássico italiano fechado na massa: tomate, mussarela e manjericão",
    desc: "Molho de tomate, mussarela e manjericão fresco fechados na massa",
    emoji: "",
    custom: { tipo: "calzone",
      base: { id: "vermelha", name: "Base Vermelha", desc: "Massa Artesanal + Molho de Tomate", price: 80 },
      selections: {
        queijos: ["mussarela"],
        toque: ["manjericao_fresco"],
        temperos: ["oregano"],
      }
    }
  },
  {
    id: "cz_bufala",
    name: "Búfala & Tomate Cereja",
    tagline: "Búfala cremosa e tomate doce, derretidos por dentro",
    desc: "Mussarela de búfala, tomate cereja e manjericão fresco por dentro",
    emoji: "",
    custom: { tipo: "calzone",
      base: { id: "vermelha", name: "Base Vermelha", desc: "Massa Artesanal + Molho de Tomate", price: 80 },
      selections: {
        queijos: ["bufala"],
        extras: ["tomate_cereja"],
        toque: ["manjericao_fresco"],
        temperos: ["oregano"],
      }
    }
  },
  {
    id: "cz_presunto",
    name: "Presunto & Mussarela",
    tagline: "O calzone de sempre: presunto e mussarela derretida",
    desc: "Presunto cozido e mussarela derretida, o clássico dos calzoni",
    emoji: "",
    custom: { tipo: "calzone",
      base: { id: "vermelha", name: "Base Vermelha", desc: "Massa Artesanal + Molho de Tomate", price: 80 },
      selections: {
        queijos: ["mussarela"],
        proteinas: "presunto",
        temperos: ["oregano"],
      }
    }
  },
  {
    id: "cz_calabresa",
    name: "Calabresa Especial",
    tagline: "Calabresa e cebola: o brasileiro de coração",
    desc: "Calabresa especial, mussarela e cebola crua fechadas na massa",
    emoji: "",
    custom: { tipo: "calzone",
      base: { id: "vermelha", name: "Base Vermelha", desc: "Massa Artesanal + Molho de Tomate", price: 80 },
      selections: {
        queijos: ["mussarela"],
        proteinas: "calabresa",
        extras: ["cebola_crua"],
        temperos: ["oregano"],
      }
    }
  },
  {
    id: "cz_salame",
    name: "Salame Italiano",
    tagline: "Salame italiano de verdade num recheio generoso",
    desc: "Salame italiano e mussarela tradicional, recheio generoso",
    emoji: "",
    custom: { tipo: "calzone",
      base: { id: "vermelha", name: "Base Vermelha", desc: "Massa Artesanal + Molho de Tomate", price: 80 },
      selections: {
        queijos: ["mussarela"],
        proteinas: "salame",
        temperos: ["oregano"],
      }
    }
  },
  {
    id: "cz_calabresa_alho",
    name: "Calabresa, Alho & Azeitona",
    tagline: "Sabor forte por dentro: alho frito e azeitona",
    desc: "Calabresa especial, mussarela, alho frito e azeitona por dentro",
    emoji: "",
    custom: { tipo: "calzone",
      base: { id: "vermelha", name: "Base Vermelha", desc: "Massa Artesanal + Molho de Tomate", price: 80 },
      selections: {
        queijos: ["mussarela"],
        proteinas: "calabresa",
        extras: ["azeitona_roxa"],
        temperos: ["oregano", "alho"],
      }
    }
  },
  {
    id: "cz_gorgonzola_trufado",
    name: "Gorgonzola & Azeite Trufado",
    tagline: "Elegante e intenso, fechado na massa",
    desc: "Gorgonzola, parmesão e azeite trufado fechados na massa",
    emoji: "",
    custom: { tipo: "calzone",
      base: { id: "vermelha", name: "Base Vermelha", desc: "Massa Artesanal + Molho de Tomate", price: 80 },
      selections: {
        queijos: ["gorgonzola", "parmesao"],
        toque: ["azeite_trufado"],
        temperos: ["oregano"],
      }
    }
  },
  {
    id: "cz_pesto",
    name: "Pesto & Tomate Cereja",
    tagline: "Verão italiano por dentro: pesto e tomate cereja",
    desc: "Pesto genovese, parmesão, mussarela, tomate cereja e manjericão fresco",
    emoji: "",
    custom: { tipo: "calzone",
      base: { id: "vermelha", name: "Base Vermelha", desc: "Massa Artesanal + Molho de Tomate", price: 80 },
      selections: {
        queijos: ["mussarela", "parmesao"],
        extras: ["tomate_cereja"],
        toque: ["pesto_genovese", "manjericao_fresco"],
      }
    }
  },
  {
    id: "cz_salame_picante",
    name: "Salame Picante",
    tagline: "Para quem gosta de fogo: salame e Tabasco",
    badge: "🔥 Picante",
    desc: "Salame italiano, mussarela e Tabasco: o calzone que arde na medida",
    emoji: "",
    custom: { tipo: "calzone",
      base: { id: "vermelha", name: "Base Vermelha", desc: "Massa Artesanal + Molho de Tomate", price: 80 },
      selections: {
        queijos: ["mussarela"],
        proteinas: "salame",
        temperos: ["oregano", "tabasco"],
      }
    }
  },
  {
    id: "cz_dois_queijos_salame",
    name: "Dois Queijos & Salame",
    tagline: "Gorgonzola, mussarela e salame: intenso e farto",
    desc: "Mussarela e gorgonzola derretidos com salame italiano",
    emoji: "",
    custom: { tipo: "calzone",
      base: { id: "vermelha", name: "Base Vermelha", desc: "Massa Artesanal + Molho de Tomate", price: 80 },
      selections: {
        queijos: ["mussarela", "gorgonzola"],
        proteinas: "salame",
        temperos: ["oregano"],
      }
    }
  },
  {
    id: "cz_queijos_derretidos",
    name: "Queijos Derretidos",
    tagline: "Quatro queijos derretendo no vapor da massa",
    desc: "Mussarela, gorgonzola, parmesão e provolone derretidos no vapor da massa",
    emoji: "",
    custom: { tipo: "calzone",
      base: { id: "vermelha", name: "Base Vermelha", desc: "Massa Artesanal + Molho de Tomate", price: 80 },
      selections: {
        queijos: ["mussarela", "gorgonzola", "parmesao", "provolone"],
        temperos: ["oregano"],
      }
    }
  },
  {
    id: "marinara",
    name: "Marinara",
    tagline: "A mais antiga de Nápoles: sem queijo, só sabor. Vegana",
    desc: "Sem queijo: alho frito, azeite de manjericão e tomate cereja",
    emoji: "🌱",
    custom: { tipo: "napoletana",
      base: { id: "vermelha", name: "Base Vermelha", desc: "Massa Artesanal + Molho de Tomate", price: 80 },
      selections: {
        queijos: ["sem_queijo"],
        extras: ["tomate_cereja"],
        toque: ["azeite_manjericao"],
        temperos: ["oregano", "alho"],
      }
    }
  },
  {
    id: "pz_presunto_provolone",
    name: "Presunto & Provolone",
    tagline: "Provolone e presunto: reconfortante e farta",
    desc: "Presunto cozido e provolone com cebola crua e orégano",
    emoji: "",
    custom: { tipo: "napoletana",
      base: { id: "vermelha", name: "Base Vermelha", desc: "Massa Artesanal + Molho de Tomate", price: 80 },
      selections: {
        queijos: ["provolone"],
        proteinas: "presunto",
        extras: ["cebola_crua"],
        temperos: ["oregano"],
      }
    }
  },
  {
    id: "pz_azeitonas_alho",
    name: "Azeitonas & Alho",
    tagline: "Mediterrânea e simples: azeitonas e alho frito",
    desc: "Azeitonas verdes e roxas com alho frito sobre mussarela",
    emoji: "",
    custom: { tipo: "napoletana",
      base: { id: "vermelha", name: "Base Vermelha", desc: "Massa Artesanal + Molho de Tomate", price: 80 },
      selections: {
        queijos: ["mussarela"],
        extras: ["azeitona_verde", "azeitona_roxa"],
        temperos: ["oregano", "alho"],
      }
    }
  },
  {
    id: "pz_gorgonzola_cebola",
    name: "Gorgonzola & Cebola Caramelizada",
    tagline: "Doce e salgado: cebola caramelizada com gorgonzola",
    desc: "Gorgonzola e cebola caramelizada: doce e salgado na medida",
    emoji: "",
    custom: { tipo: "napoletana",
      base: { id: "vermelha", name: "Base Vermelha", desc: "Massa Artesanal + Molho de Tomate", price: 80 },
      selections: {
        queijos: ["mussarela", "gorgonzola"],
        extras: ["cebola_caramelizada"],
        temperos: ["oregano"],
      }
    }
  },
  {
    id: "pz_rucula_tomate_seco",
    name: "Rúcula & Tomate Seco",
    tagline: "A queridinha do Brasil: rúcula fresca e tomate seco",
    desc: "A brasileira favorita: rúcula fresca, tomate seco e parmesão",
    emoji: "",
    custom: { tipo: "napoletana",
      base: { id: "vermelha", name: "Base Vermelha", desc: "Massa Artesanal + Molho de Tomate", price: 80 },
      selections: {
        queijos: ["mussarela", "parmesao"],
        extras: ["rucula", "tomate_seco"],
        temperos: ["oregano"],
      }
    }
  },
  {
    id: "pz_pesto_rucula",
    name: "Pesto de Rúcula",
    tagline: "Fresca e verde: pesto de rúcula com tomate cereja",
    desc: "Pesto de rúcula, parmesão e tomate cereja sobre mussarela",
    emoji: "",
    custom: { tipo: "napoletana",
      base: { id: "vermelha", name: "Base Vermelha", desc: "Massa Artesanal + Molho de Tomate", price: 80 },
      selections: {
        queijos: ["mussarela", "parmesao"],
        extras: ["tomate_cereja"],
        toque: ["pesto_rucula"],
        temperos: ["oregano"],
      }
    }
  },
  {
    id: "pz_frango_cebola",
    name: "Frango & Cebola Caramelizada",
    tagline: "Frango desfiado e cebola doce: sabor de casa",
    desc: "Frango desfiado com cebola caramelizada e mussarela",
    emoji: "",
    custom: { tipo: "napoletana",
      base: { id: "vermelha", name: "Base Vermelha", desc: "Massa Artesanal + Molho de Tomate", price: 80 },
      selections: {
        queijos: ["mussarela"],
        proteinas: "frango",
        extras: ["cebola_caramelizada"],
        temperos: ["oregano"],
      }
    }
  },
  {
    id: "pz_bufala_trufada",
    name: "Búfala Trufada",
    tagline: "Búfala e azeite trufado: sofisticada em cada mordida",
    desc: "Mussarela de búfala com azeite trufado e manjericão fresco",
    emoji: "",
    custom: { tipo: "napoletana",
      base: { id: "vermelha", name: "Base Vermelha", desc: "Massa Artesanal + Molho de Tomate", price: 80 },
      selections: {
        queijos: ["bufala"],
        toque: ["azeite_trufado", "manjericao_fresco"],
      }
    }
  },
  {
    id: "pz_salame_rucula",
    name: "Salame & Rúcula",
    tagline: "Clássico de Roma: salame, rúcula e parmesão",
    desc: "Salame italiano, rúcula fresca e parmesão",
    emoji: "",
    custom: { tipo: "napoletana",
      base: { id: "vermelha", name: "Base Vermelha", desc: "Massa Artesanal + Molho de Tomate", price: 80 },
      selections: {
        queijos: ["mussarela", "parmesao"],
        proteinas: "salame",
        extras: ["rucula"],
        temperos: ["oregano"],
      }
    }
  },
  {
    id: "pz_trufa_branca",
    name: "Aroma de Trufa Branca",
    tagline: "A mais especial: o aroma intenso da trufa branca, para uma noite única",
    desc: "Mussarela e parmesão com tempero de trufa branca por cima",
    emoji: "",
    custom: { tipo: "napoletana",
      base: { id: "vermelha", name: "Base Vermelha", desc: "Massa Artesanal + Molho de Tomate", price: 80 },
      selections: {
        queijos: ["mussarela", "parmesao"],
        toque: ["trufa_branca"],
        temperos: ["oregano"],
      }
    }
  },
  {
    id: "cz_presunto_provolone",
    name: "Presunto, Provolone & Cebola",
    tagline: "Provolone e presunto: reconfortante e farto",
    desc: "Presunto cozido, provolone e cebola fechados na massa",
    emoji: "",
    custom: { tipo: "calzone",
      base: { id: "vermelha", name: "Base Vermelha", desc: "Massa Artesanal + Molho de Tomate", price: 80 },
      selections: {
        queijos: ["provolone"],
        proteinas: "presunto",
        extras: ["cebola_crua"],
        temperos: ["oregano"],
      }
    }
  },
  {
    id: "cz_azeitonas_alho",
    name: "Duas Azeitonas & Alho",
    tagline: "Mediterrâneo, fechado na massa",
    desc: "Azeitonas verdes e roxas com alho frito, tudo dentro",
    emoji: "",
    custom: { tipo: "calzone",
      base: { id: "vermelha", name: "Base Vermelha", desc: "Massa Artesanal + Molho de Tomate", price: 80 },
      selections: {
        queijos: ["mussarela"],
        extras: ["azeitona_verde", "azeitona_roxa"],
        temperos: ["oregano", "alho"],
      }
    }
  },
  {
    id: "cz_gorgonzola_agridoce",
    name: "Gorgonzola Agridoce",
    tagline: "Doce e salgado: cebola caramelizada e gorgonzola",
    desc: "Gorgonzola com cebola caramelizada: doce e salgado por dentro",
    emoji: "",
    custom: { tipo: "calzone",
      base: { id: "vermelha", name: "Base Vermelha", desc: "Massa Artesanal + Molho de Tomate", price: 80 },
      selections: {
        queijos: ["mussarela", "gorgonzola"],
        extras: ["cebola_caramelizada"],
        temperos: ["oregano"],
      }
    }
  },
  {
    id: "cz_rucula_tomate_seco",
    name: "Rúcula, Tomate Seco & Parmesão",
    tagline: "A queridinha do Brasil, em versão calzone",
    desc: "Rúcula, tomate seco e parmesão fechados na massa",
    emoji: "",
    custom: { tipo: "calzone",
      base: { id: "vermelha", name: "Base Vermelha", desc: "Massa Artesanal + Molho de Tomate", price: 80 },
      selections: {
        queijos: ["mussarela", "parmesao"],
        extras: ["rucula", "tomate_seco"],
        temperos: ["oregano"],
      }
    }
  },
  {
    id: "cz_pesto_rucula",
    name: "Pesto de Rúcula & Tomate Cereja",
    tagline: "Fresco e verde por dentro",
    desc: "Pesto de rúcula, parmesão e tomate cereja por dentro",
    emoji: "",
    custom: { tipo: "calzone",
      base: { id: "vermelha", name: "Base Vermelha", desc: "Massa Artesanal + Molho de Tomate", price: 80 },
      selections: {
        queijos: ["mussarela", "parmesao"],
        extras: ["tomate_cereja"],
        toque: ["pesto_rucula"],
        temperos: ["oregano"],
      }
    }
  },
  {
    id: "cz_frango_caramelizado",
    name: "Frango Caramelizado",
    tagline: "Frango desfiado e cebola doce: sabor de casa",
    desc: "Frango desfiado com cebola caramelizada, recheio farto",
    emoji: "",
    custom: { tipo: "calzone",
      base: { id: "vermelha", name: "Base Vermelha", desc: "Massa Artesanal + Molho de Tomate", price: 80 },
      selections: {
        queijos: ["mussarela"],
        proteinas: "frango",
        extras: ["cebola_caramelizada"],
        temperos: ["oregano"],
      }
    }
  },
  {
    id: "cz_bufala_trufada",
    name: "Búfala & Azeite Trufado",
    tagline: "Sofisticado em cada mordida",
    desc: "Mussarela de búfala com azeite trufado e manjericão, por dentro",
    emoji: "",
    custom: { tipo: "calzone",
      base: { id: "vermelha", name: "Base Vermelha", desc: "Massa Artesanal + Molho de Tomate", price: 80 },
      selections: {
        queijos: ["bufala"],
        toque: ["azeite_trufado", "manjericao_fresco"],
      }
    }
  },
  {
    id: "cz_salame_rucula",
    name: "Salame, Rúcula & Parmesão",
    tagline: "Clássico romano, fechado e quentinho",
    desc: "Salame italiano, rúcula e parmesão fechados na massa",
    emoji: "",
    custom: { tipo: "calzone",
      base: { id: "vermelha", name: "Base Vermelha", desc: "Massa Artesanal + Molho de Tomate", price: 80 },
      selections: {
        queijos: ["mussarela", "parmesao"],
        proteinas: "salame",
        extras: ["rucula"],
        temperos: ["oregano"],
      }
    }
  },
  {
    id: "cz_trufa_branca",
    name: "Aroma de Trufa & Parmesão",
    tagline: "O mais especial: aroma intenso de trufa branca, fechado na massa",
    desc: "Mussarela, parmesão e tempero de trufa branca por dentro",
    emoji: "",
    custom: { tipo: "calzone",
      base: { id: "vermelha", name: "Base Vermelha", desc: "Massa Artesanal + Molho de Tomate", price: 80 },
      selections: {
        queijos: ["mussarela", "parmesao"],
        toque: ["trufa_branca"],
        temperos: ["oregano"],
      }
    }
  },
  {
    id: "pz_dolce_vita",
    name: "Dolce Vita",
    tagline: "A sobremesa: pizza doce de Nutella, quentinha do forno",
    badge: "🍫 Sobremesa",
    desc: "Massa artesanal de 48h assada sem molho e coberta de Nutella na saída do forno",
    emoji: "🍫",
    custom: { tipo: "napoletana", fixo: true,
      base: { id: "doce", name: "Massa Doce", desc: "Massa Artesanal sem molho", price: 70 },
      selections: {
        queijos: ["sem_queijo"],
        toque: ["nutella"],
      }
    }
  },
  {
    id: "pz_palmito",
    name: "Palmito & Tomate Cereja",
    tagline: "Leve e brasileira: palmito com tomate cereja",
    desc: "Palmito, tomate cereja e mussarela com orégano",
    emoji: "",
    custom: { tipo: "napoletana",
      base: { id: "vermelha", name: "Base Vermelha", desc: "Massa Artesanal + Molho de Tomate", price: 80 },
      selections: {
        queijos: ["mussarela"],
        extras: ["palmito", "tomate_cereja"],
        temperos: ["oregano"],
      }
    }
  },
  {
    id: "cz_palmito",
    name: "Palmito & Mussarela",
    tagline: "Leve e brasileiro: palmito e mussarela",
    desc: "Palmito e tomate cereja com mussarela, fechados na massa",
    emoji: "",
    custom: { tipo: "calzone",
      base: { id: "vermelha", name: "Base Vermelha", desc: "Massa Artesanal + Molho de Tomate", price: 80 },
      selections: {
        queijos: ["mussarela"],
        extras: ["palmito", "tomate_cereja"],
        temperos: ["oregano"],
      }
    }
  },
];
